import { ReactComponent as EditIcon } from 'assets/icons/pencil.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import IconButton from 'components/IconButton/IconButton';

import type ITaskInfoHeader from './interfaces/ITaskInfoHeader';

import styles from './sass/TaskInfoHeader.module.scss';

function TaskInfoHeader({
  title,
  onEdit,
  onDelete,
  className,
  canEdit,
}: ITaskInfoHeader) {
  return (
    <div className={`${styles.header} ${className || ''}`}>
      <h3>{title}</h3>
      {canEdit ? (
        <div className={styles.buttonWrapper}>
          <IconButton
            icon={<EditIcon />}
            onClick={onEdit}
            className={styles.button}
          />
          <IconButton
            icon={<TrashIcon />}
            onClick={onDelete}
            className={styles.button}
          />
        </div>
      ) : null}
    </div>
  );
}

export default TaskInfoHeader;
